<template>
  <div class="rt-list-header">
    <div class="rt-list-header-top">
      <div class="header-icon"><slot name="icon" /></div>
      <div class="header-content"><slot /></div>
      <div class="header-btns"><slot name="btn" /></div>
      <div class="header-search"><slot name="search" /></div>
    </div>
    <div class="rt-list-header-bottom"><slot name="subcontent" /></div>
  </div>
</template>

<script>
export default {
  name: 'RtListHeader'
};
</script>

<style lang="less">
.rt-list-header {
  background: #fff;
  .rt-list-header-top {
    display: flex;

    padding: 16px 20px 14px 20px;
    position: relative;
    z-index: 1;
    align-items: center;
    .header-icon {
      margin-right: 20px;
    }
    .header-content {
      flex: 1;
    }
    .header-btns {
      display: flex;
      align-items: center;
      margin-right: 30px;
    }
  }
  .rt-list-header-bottom {
    padding: 0 0 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// rtListHeader.vue?97ca3a9a